import React, { useEffect, useState } from "react";
import { AutenticacionAction } from "../../Actions/Auth/LoginAction";
import { useDispatch } from "react-redux";
import { types } from "../../Helpers/Types";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { LoaderScreen } from "../components/LoaderScreen";
import OneSignal from "react-onesignal";

export const MFAScreen = () => {
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const dispatch = useDispatch();
  const [codigo, setCodigo] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();
  const location = useLocation();

  const addValue = ({ value }) => {
    if (value.length > 6) return;
    setCodigo(value);
  };

  const onAutenticar = async () => {
    setLoader({ ...loader, mostrar: true });

    if (codigo.length !== 6) {
      setError("El codigo proporcionado no es valido");
      setLoader({ ...loader, mostrar: false });
      return;
    }

    const { actualizarpassword, idusuario, token } = location.state;

    try {
      let oneSignalID = null;

      try {
        oneSignalID = await OneSignal.User.PushSubscription.id;
      } catch (e) {
        console.log("⚠ No se pudo obtener la suscripción:", e);
      }

      // 🔥 Enviarlo a la acción
      const result = await AutenticacionAction(
        idusuario,
        codigo,
        token,
        oneSignalID
      );

      setLoader({ ...loader, mostrar: false });

      if (actualizarpassword === true) {
        history.push(`/auth/updatepassword`, {
          token: result.token,
          usuario: idusuario,
          menus: result.menus,
          modulos: result.modulos,
          presas: result.presas,
        });
      } else {
        localStorage.setItem("HumayaDigital-Token", result.token);

        dispatch({
          type: types.usuario,
          payload: {
            idempleado: result.usuario.idempleado,
            empleado: result.usuario.empleado,
            sucursal: result.usuario.sucursal,
            departamento: result.usuario.departamento,
            puesto: result.usuario.puesto,
            adr: result.usuario.adr,
          },
        });

        dispatch({
          type: types.sesion,
          payload: {
            menus: result.menus,
            modulos: result.modulos,
            presas: result.presas,
            autenticado: true,
            roles: result.roles
          },
        });
      }
    } catch (error) {
      setLoader({ ...loader, mostrar: false });

      if (error.Message) setError(error.Message);
      else if (error.Mensaje) setError(error.Mensaje);
      else if (error.mensaje) setError(error.mensaje);
      else
        setError(
          "Error del servidor, favor de comunicarse con el administrador del sistema"
        );
    }
  };
  return (
    <>
      <div className="form-login-controls">
        <LoaderScreen loader={loader} />
        <div className="mfa-titulo">AUTENTICACION MULTIFACTOR</div>
        <div className="mfa-label">CODIGO DE SEGURIDAD</div>
        <div className="mfa-container">
          <input
            type="text"
            id="codigoseguridad"
            className="mfa-input-codigo-seguridad"
            value={codigo}
            onChange={({ target }) => addValue(target)}
          />
          {error !== undefined && error !== null && error !== "" ? (
            <div className="mensaje-error scroll-4">
              <div className="mensaje-error-effect">
                <div className="mensaje-error-effect-icono">!</div>
              </div>
              <div className="mensaje-error-effect-contenido">{error}</div>
            </div>
          ) : (
            <div></div>
          )}
          <button
            className="mfa-btn-codigo-seguridad"
            onClick={() => onAutenticar()}
          >
            SIGUIENTE
          </button>
        </div>
      </div>
    </>
  );
};
